import { FileValidationResult } from '@/models/FileValidationResult'
import { getExtension, humanFileSize } from '@/modules/filesystem'

const MAX_FILESIZE = 6291456
const MAX_IMAGE_DIMENSION = 1280
const ALLOWED_IMG_EXT = ['gif', 'png', 'jpg', 'jpeg']
const ALLOWED_DOC_EXT = ['doc', 'docx', 'pdf']
const MAX_NUM_FILES = 3

class FileValidationService {
    private checkType (file: File): boolean {
        const ext = getExtension(file.name)
        if (!ext) return false
        return [...ALLOWED_IMG_EXT, ...ALLOWED_DOC_EXT].includes(ext)
    }

    private checkSize (file: File): boolean {
        return file.size < MAX_FILESIZE
    }

    private isAllowed (file: File, types: string[]): boolean {
        const ext = getExtension(file.name)
        if (!ext) return false
        return types.includes(ext)
    }

    public get maxSize() {
        return MAX_FILESIZE
    }

    public get maxImageDimension() {
        return MAX_IMAGE_DIMENSION
    }

    public get maxNumFiles() {
        return MAX_NUM_FILES
    }

    validate (file: File): FileValidationResult {
        if (!this.checkType(file)) return { isOk: false, message: 'El documento debe ser una imagen, pdf o microsoft word.' }
        if (!this.checkSize(file) && this.isAllowedDoc(file)) return { isOk: false, message: `Tamaño máximo permitido es ${humanFileSize(MAX_FILESIZE)}.`}

        return { isOk: true, message: null }
    }

    isAllowedImage (file: File): boolean {
        return this.isAllowed(file, ALLOWED_IMG_EXT)
    }

    isAllowedDoc (file: File): boolean {
        return this.isAllowed(file, ALLOWED_DOC_EXT)
    }
}


export const fileValidationService = new FileValidationService()
